import React from "react"

const BobAndSaylor = () => (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="126"
      height="119"
      viewBox="0 0 126 119"
    >
      <defs>
        <path id="a" d="M.322.178h58.163v34.466H.322z" />
        <path id="c" d="M.504.07H15.74v14.353H.504z" />
        <path id="e" d="M0 .024h34.452V37.77H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#BAD9EA"
          d="M90.453 105.016c-9.241 0-16.732 2.762-16.732 6.17 0 3.409 7.491 6.17 16.732 6.17 9.239 0 16.728-2.761 16.728-6.17 0-3.408-7.49-6.17-16.728-6.17"
        />
        <path
          fill="#FF3D49"
          d="M67.897 56.958c3.972.698 7.771-1.956 8.472-5.916.7-3.959-1.961-7.75-5.932-8.449-3.971-.697-7.77 1.958-8.47 5.917-.7 3.96 1.96 7.749 5.93 8.448"
        />
        <path
          fill="#FFCA67"
          d="M118.603 67.19h.004l2.541-27.542c1.272-13.77-7.51-25.72-19.505-27.834-11.998-2.113-24.338 6.116-27.857 19.488l.005.001-7.037 26.74.004.002c-4.636 17.768 4.025 35.992 19.885 38.786 15.856 2.794 30.23-11.366 31.96-29.642"
        />
        <path
          stroke="#FFA887"
          strokeWidth="2"
          d="M96.674 5.976a5.471 5.471 0 0 0 4.448 6.336c2.982.525 5.829-1.462 6.353-4.436a5.47 5.47 0 0 0-4.448-6.336c-2.983-.525-5.827 1.462-6.353 4.436z"
        />
        <g transform="translate(61.855 63.451)">
          <mask id="b" fill="#fff">
            <use href="#a" />
          </mask>
          <path
            fill="#FF3D49"
            d="M58.485 10.406C55.637 26.365 40.463 37.01 24.547 34.193 8.628 31.376-2.005 16.156.76.179L.758.178l57.727 10.228z"
            mask="url(#b)"
          />
        </g>
        <g transform="translate(109.388 52.135)">
          <mask id="d" fill="#fff">
            <use href="#c" />
          </mask>
          <path
            fill="#FF3D49"
            d="M6.799 14.313c4.137.687 8.096-1.924 8.825-5.821.73-3.896-2.043-7.627-6.178-8.313C5.309-.508 1.35 2.104.62 6c-.73 3.897 2.041 7.625 6.178 8.313"
            mask="url(#d)"
          />
        </g>
        <path
          fill="#FFA887"
          d="M101.19 11.817c-8.582-1.534-17.322 2.337-22.882 9.635l41.135 7.355c-2.764-8.785-9.67-15.456-18.252-16.99"
        />
        <path
          fill="#FFF"
          d="M83.695 42.89a3.196 3.196 0 0 1-2.595-3.697 3.202 3.202 0 0 1 3.707-2.588A3.196 3.196 0 0 1 87.4 40.3a3.202 3.202 0 0 1-3.706 2.588M97.406 44.713a3.194 3.194 0 0 1-2.595-3.697 3.202 3.202 0 0 1 3.707-2.588 3.197 3.197 0 0 1 2.594 3.697 3.204 3.204 0 0 1-3.706 2.588"
        />
        <g>
          <path
            fill="#BAD9EA"
            d="M17.297 109.714c-6.089 0-11.025 1.86-11.025 4.154 0 2.294 4.936 4.154 11.025 4.154s11.024-1.86 11.024-4.154c0-2.294-4.935-4.154-11.024-4.154"
          />
          <g transform="translate(0 65.648)">
            <mask id="f" fill="#fff">
              <use href="#e" />
            </mask>
            <path
              fill="#FFCA67"
              d="M34.452 20.544C34.452 11.6 27.64 4.25 18.92 3.4a4.346 4.346 0 0 0-8.567 1.347C4.26 7.403 0 13.474 0 20.544 0 30.058 7.711 37.77 17.226 37.77c9.514 0 17.226-7.712 17.226-17.226z"
              mask="url(#f)"
            />
          </g>
          <path
            fill="#FFF"
            d="M19.51 80.665a1.89 1.89 0 0 1-2.185-1.53 1.89 1.89 0 0 1 1.53-2.186 1.888 1.888 0 0 1 2.185 1.53 1.888 1.888 0 0 1-1.53 2.186M26.938 79.355a1.89 1.89 0 0 1-2.186-1.53 1.89 1.89 0 0 1 1.53-2.186 1.888 1.888 0 0 1 2.185 1.53 1.888 1.888 0 0 1-1.53 2.186"
          />
        </g>
      </g>
    </svg>
  </React.Fragment>
)

export default BobAndSaylor



// WEBPACK FOOTER //
// ./static/images/dashboard/bob-and-saylor.js